var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAi01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\uB808\\uC774\\uC5B4_2",
    "data-name": "\\uB808\\uC774\\uC5B4 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 26.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\uB808\\uC774\\uC5B4_2-2",
    "data-name": "\\uB808\\uC774\\uC5B4 2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26,11.72h-.07c-.99-4.33-4.86-7.57-9.5-7.57h-1.83v-.71c.68-.25,1.17-.9,1.17-1.67,0-.98-.8-1.78-1.78-1.78s-1.78.8-1.78,1.78c0,.77.49,1.42,1.17,1.67v.71h-1.83c-4.63,0-8.51,3.24-9.5,7.57h-.07c-1.1,0-2,.89-2,2v2.86c0,1.1.89,2,2,2h.18c.79,2.46,2.83,4.36,5.39,4.91v3.01l6.5-2.84h4.81c3.26,0,6.02-2.13,6.96-5.08h.16c1.1,0,2-.89,2-2v-2.86c0-1.1-.89-2-2-2ZM23.75,16.43c0,2.69-2.18,4.88-4.88,4.88h-9.75c-2.69,0-4.88-2.18-4.88-4.88v-1.22c0-3.37,2.73-6.09,6.09-6.09h7.31c3.37,0,6.09,2.73,6.09,6.09v1.22Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 9.38,
    y: 13.25,
    width: 1.83,
    height: 3.05,
    rx: 0.91,
    ry: 0.91
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 16.79,
    y: 13.25,
    width: 1.83,
    height: 3.05,
    rx: 0.91,
    ry: 0.91
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAi01);
export default __webpack_public_path__ + "static/media/ai-01.a1e5de62ab74377e3a4dbe3867f8417c.svg";
export { ForwardRef as ReactComponent };